import { useState, useEffect } from 'react';

import apiRequest from '../util/apiRequest';

export default function useApi(
    url,
    method = apiRequest.get, // Default to GET
    postprocess = r => r // Default to Identity, no modifications
) {
    const [data, setData] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Skip if no URL specified
        if (!url) return;

        let isMounted = true;

        async function fetchData() {
            setFetching(true);

            try {
                const response = await method(url);

                if (isMounted) {
                    setData(postprocess(response));
                    setError(null);
                }
            } catch (e) {
                if (isMounted) {
                    setData(null);
                    setError(e);
                    console.error(e);
                }
            } finally {
                if (isMounted) {
                    setFetching(false);
                }
            }
        }

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [url, method, postprocess]); // Only refetch if inputs change

    return { data, fetching, error };
}
